<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    <v-row justify="center">
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">Reportes</p>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="4" offset="4">
                <v-select
                  dense
                  outlined
                  label="Competencia"
                  :items="competencias"
                  item-value="id"
                  item-text="competencia"
                  v-model="competencia"
                  return-object
                  @change="actualizarDatosCompetencia"
                >
                </v-select>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Categoria"
                  :items="categoriasCompetencia"
                  item-value="categoria_id"
                  item-text="categoria"
                  v-model="categoria"
                >
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Regional"
                  :items="regionales"
                  item-value="id"
                  item-text="regional"
                  v-model="regional"
                  @change="actualizarDatosRegional"
                >
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Centro de formación"
                  :items="centrosFormacion"
                  item-value="id"
                  item-text="centro_formacion"
                  v-model="centroFormacion"
                >
                </v-autocomplete>

                <v-checkbox 
                  v-model="senasoft" 
                  label="Cupos" 
                  value="cupos"
                >
                </v-checkbox>

                <v-checkbox
                  v-model="senasoft"
                  label="Participantes"
                  value="participantes"
                >
                </v-checkbox>

                <v-checkbox 
                  v-model="senasoft"
                  label="Lideres" 
                  value="lideres"
                >
                </v-checkbox>

                <v-checkbox
                  v-model="senasoft"
                  label="Categorias"
                  value="categorias"
                >
                </v-checkbox>

                <v-btn
                  large
                  block
                  exact
                  elevation="2"
                  color="primary"
                  class="mt-2 mb-6"
                  @click="reporteSenasoft"
                >
                  Descargar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    competencia: null,
    categoria: null,
    regional: null,
    centroFormacion: null,

    senasoft: [],
  }),

  components: {
    Alert,
  },

  mounted() {
    this.$store.dispatch("gestionarCompetencias");
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
  },

  computed: {
    competencias() {
      return this.$store.getters.obtenerCompetencias;
    },
    
    categoriasCompetencia() {
      return this.$store.getters.obtenerCategoriasCompetencia;
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacionReporte(this.regional);
    },
  },

  methods: {
    actualizarDatosCompetencia() {
      this.$store.dispatch(
        "gestionarCategoriasCompetencia",
        this.competencia.id
      );
    },

    actualizarDatosRegional() {
      this.$store.dispatch("crearCentrosFormacion");
    },

    reporteSenasoft() {
      if (this.competencia) {
        if (this.senasoft.length > 0) {
          const reporte = {
            competencia: this.competencia.id,
            categoria: this.categoria,
            regional: this.regional,
            centro_formacion: this.centroFormacion,
            datos: this.senasoft,
          };

          this.$store.dispatch("reporteSenasoft", reporte)
            .then((response) => {
              const urlReporte = window.URL.createObjectURL(
                new Blob([response])
              );
              const link = document.createElement("a");
              link.href = urlReporte;
              link.setAttribute(
                "download", `${this.competencia.competencia}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              this.senasoft = [];
              this.alertTitle = "Descargado";
              this.alertMessage = "Reporte con éxito";
              this.alertType = "success--text";
              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 1000);
            })
            .catch(() => {});
        } else {
          this.alertTitle = "Error";
          this.alertType = "error--text";
          this.alertMessage = "Seleccione items para descargar";
          this.titleCard = "error--text";
          this.alert = true;
        }
      } else {
        this.alertTitle = "Error";
        this.alertType = "error--text";
        this.alertMessage = "Seleccione una competencia";
        this.titleCard = "error--text";
        this.alert = true;
      }

      setTimeout(() => {
        this.alert = false;
      }, 2000);
    },
  },
};
</script>
